import { useEffect, useState } from "react";
import { StandardModal } from "@/components/StandardModal";
import { Button } from "@/components/ui/button";
import { PeriodRangeCalendar, isoFromState } from "@/components/PeriodRangeCalendar";
import { useClientConfig } from "@/contexts/ClientConfigContext";
import { BTN_PAGE_PRIMARY_ACTION } from "@/lib/buttonStyles";
import { MODAL_BODY_CLASS, MODAL_FOOTER_STICKY_MOBILE_CLASS, MODAL_PANEL_MAX_HEIGHT_CLASS } from "@/lib/modalStyles";

type ModalPeriodoPersonalizadoProps = {
  open: boolean;
  onClose: () => void;
  inicio: string;
  fim: string;
  onInicioChange: (value: string) => void;
  onFimChange: (value: string) => void;
  onApply: () => void;
};

export function ModalPeriodoPersonalizado({
  open,
  onClose,
  inicio,
  fim,
  onInicioChange,
  onFimChange,
  onApply,
}: ModalPeriodoPersonalizadoProps) {
  const { config } = useClientConfig();
  const [inicioMonth, setInicioMonth] = useState(() => isoFromState(inicio));
  const [fimMonth, setFimMonth] = useState(() => isoFromState(fim));
  const showAction = inicio.length === 10 && fim.length === 10;

  useEffect(() => {
    if (!open) return;
    setInicioMonth(isoFromState(inicio));
    setFimMonth(isoFromState(fim));
  }, [open, inicio, fim]);

  const handleInicioSelect = (iso: string) => {
    onInicioChange(iso);
    if (fim.length === 10 && iso > fim) onFimChange(iso);
  };

  const handleFimSelect = (iso: string) => {
    onFimChange(iso);
    if (inicio.length === 10 && iso < inicio) onInicioChange(iso);
  };

  return (
    <StandardModal
      open={open}
      title="Selecione o período"
      onClose={onClose}
      panelClassName={`!max-w-xl ${MODAL_PANEL_MAX_HEIGHT_CLASS}`}
    >
      <div className={MODAL_BODY_CLASS}>
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <PeriodRangeCalendar
            viewMonth={inicioMonth}
            onViewMonthChange={setInicioMonth}
            selectedIso={inicio}
            onSelect={handleInicioSelect}
            primaryColor={config.primary_color}
            ariaLabel="Calendário da data de início"
          />
          <PeriodRangeCalendar
            viewMonth={fimMonth}
            onViewMonthChange={setFimMonth}
            selectedIso={fim}
            onSelect={handleFimSelect}
            primaryColor={config.primary_color}
            ariaLabel="Calendário da data final"
          />
        </div>
        {showAction ? (
          <div className={`flex justify-end pt-2 ${MODAL_FOOTER_STICKY_MOBILE_CLASS}`}>
            <Button type="button" className={BTN_PAGE_PRIMARY_ACTION} onClick={onApply}>
              Aplicar
            </Button>
          </div>
        ) : null}
      </div>
    </StandardModal>
  );
}
